// encode object to uri query string
export default function encodeQueryData(data) {
  const ret = [];
  for (const d in data) {
    if (data[d]) {
      ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
    }
  }
  return "?" + ret.join("&");
}
